import { types, actions } from './requests'
export const CREATEDOCUMENT_TYPES = {
    ...types('CREATEDOCUMENT'),
}
export const CREATEDOCUMENT_ACTIONS = {
    ...actions('CREATEDOCUMENT'),
}
